import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPython, faReact, faFlickr } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

// Skills categories with a story format
const expertiseData = [
    {
        icon: faFlickr,
        title: "Computer Vision",
        description: `
            I explored advanced techniques while working as a Graduate Research Assistant at the CVAR lab, 
            where I contributed to projects on Cross-View Geo-Localization. The culmination of these experiences 
            led me to my current role as a Research Engineer II, where I tackle real-world challenges in vision-based robotics.
        `,
        techStack: [
            "OpenCV",
            "PyTorch",
            "TensorFlow",
            "Keras",
            "Attention-based Models",
            "3D Reconstruction",
        ],
    },
    {
        icon: faPython,
        title: "Deep Learning",
        description: `
            Working with Dr. Vijay Devabaktuni and Dr. Sidike Paheding and later with Dr. Vikas Dhiman at the CVAR lab 
            provided hands-on experience with attention-based models like Transformers and pre-training strategies such as BEIT. 
            Applying these methods to domains like medical imaging and geo-localization, I’ve honed my skills and developed 
            a passion for solving complex problems with AI.
        `,
        techStack: [
            "PyTorch",
            "TensorFlow",
            "CUDA",
            "Data Processing",
            "Transformers",
            "Self-Supervised Learning",
            "Hugging Face",
        ],
    },
    {
        icon: faReact,
        title: "Web Development",
        description: `
            My Web Development journey began as a Full Stack Developer at EAIESB Software Solutions, 
            where I built scalable components in Angular and React. Later, I developed platforms for cluster monitoring 
            and low-code tools, blending my interest in automation and software engineering.
        `,
        techStack: [
            "React.js",
            "TypeScript",
            "Node.js",
            "Flask",
            "Docker",
            "AWS",
            "SQL",
            "RESTful APIs",
        ],
    },
];

function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>About Me</h1>
                <h2 className="intro-text">I love Pixels and Math.</h2>
                <h2 className="job-title">
                    Currently a Research Engineer II - Robotics at the Advanced Structures and Composites Center.
                </h2>
                <div className="skills-grid">
                    {expertiseData.map((expertise, index) => (
                        <div className="skill" key={index}>
                            <FontAwesomeIcon icon={expertise.icon} size="3x" />
                            <h3>{expertise.title}</h3>
                            <p className="description">{expertise.description}</p>
                            <div className="tech-stack">
                                <span className="chip-title">Tech Stack:</span>
                                <div className="chips-container">
                                    {expertise.techStack.map((tech, idx) => (
                                        <Chip key={idx} className="chip" label={tech} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Expertise;
